<template>
  <b-modal
    ref="modal"
    title="Compress"
    centered
    @hide="closeHandler"
  >
    <template #modal-footer>
      <ButtonOutline
        variant="outline-primary"
        @click="$refs.modal.hide()"
      >
        Cancel
      </ButtonOutline>
    </template>

    <b-spinner />
  </b-modal>
</template>

<script>
import mixinModal from './mixin'
import ButtonOutline from "../../../common/atoms/ButtonOutline.vue";

export default {
  name: "CompressLoaderModal",
  components: {ButtonOutline},
  mixins: [
    mixinModal
  ]
}
</script>

<style scoped lang="scss">

</style>